const internshipBonuses = [
  'Poznanstva u IT Svijetu',
  'Vanjska predavanja tvrtki',
  'Vlastiti portfolio',
  'Opsežno znanje',
  'Rad na super projektima',
];

export default internshipBonuses;
